exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the CertificateTemplate module should live here.\n * Import as neede like so:\n * ...\n * import certificateTemplateStyles from '.certificateTemplateModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"certificate-template-item\">\n * ...\n */\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/certificateTemplate/certificateTemplateModuleStyles.css
// module id = 1345
// module chunks = 1